<template>
  <div class="chat-select-group">
    <label v-if="label" class="select-label mb-1">{{ label }}</label>
    <soft-button
      ref="btn"
      variant="gradient"
      color="secondary"
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title="検索条件を設定します"
      @click="$emit('open-modal', true)"
    >
      <i class="fas fa-search-location me-1"></i>
      設定
    </soft-button>
  </div>
</template>

<script>
import SoftButton from '@/components/SoftButton.vue'
import { Tooltip } from '@coreui/coreui'

export default {
  name: 'ChatSelectButton',
  components: {
    SoftButton,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tooltip: null,
    }
  },
  emits: ['open-modal'],
  mounted() {
    this.tooltip = new Tooltip(this.$refs.btn.$el, {
      title: '最初に検索先を設定してね！',
      placement: 'bottom',
      trigger: 'manual',
      container: this.$el,
    })

    setTimeout(() => {
      if (this.tooltip !== null) {
        this.tooltip.show()
      }
    }, 1000)
  },
  beforeUnmount() {
    this.tooltip?.dispose()
    this.tooltip = null
  },
}
</script>
